module.exports = __webpack_public_path__ + "assets/img/openinvest-get-started-w960.33409a47.webp";